// @ts-nocheck

// App
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

// Lodash
import assign from 'lodash/assign';

// Actions
import ListingEngineActions from 'app/shared/flux/actions/ListingEngineActions';
import ErrorActions from 'app/shared/flux/actions/ErrorActions';
import DEPRECATED_FilterActions from 'app/shared/flux/actions/DEPRECATED_FilterActions';

// Models
import DEPRECATED_Filter from 'app/shared/models/DEPRECATED_Filter';

// Misc / utils
import {
  DEPRECATED_filterUtils_getFilterLabels,
  filterUtils_getDefaultFilterVal,
  filterUtils_getFilterDiff,
} from 'app/shared/utils/filterUtils';
import { yieldCallback } from '@zillow/yield-callback';

export const useDesktopLogic = () => {
  // Redux
  const dispatch = useDispatch();
  const desktopFilter = useSelector((state) => state.DEPRECATED_filter);

  // React
  const [filterLabelCounts, setFilterLabelCounts] = useState({});
  const [isLoading, setIsLoading] = useState(true);

  const desktopFilterLabels = filterUtils_getFilterDiff({
    baseFilter: DEPRECATED_Filter.create(),
    editedFilter: desktopFilter,
  });
  const keys = Object.keys(desktopFilterLabels);
  const filterLabels = keys.map((key) => {
    const val = DEPRECATED_filterUtils_getFilterLabels(key, desktopFilterLabels[key]);
    return [key, val];
  });

  const fetchNumListingsExcludedPerFilter = async () => {
    const filterLabelsAndCounts = {};

    await Promise.all(
      filterLabels.map(async (labelTuple) => {
        const key = labelTuple[0];
        const defaultValue = filterUtils_getDefaultFilterVal(key);
        const filterWithKeyReset = assign({}, desktopFilter, defaultValue);
        setIsLoading(true);
        const numOfListings = await dispatch(
          ListingEngineActions.fetchNumListingsForFilter({ filter: filterWithKeyReset }),
        );

        filterLabelsAndCounts[key] = String(numOfListings);
      }),
    );

    setFilterLabelCounts(filterLabelsAndCounts);
  };

  const fetchTotalNumListingsExcluded = async () => {
    try {
      await dispatch(ListingEngineActions.fetchNumDefaultFilterListings());
      setIsLoading(false);
    } catch (err) {
      dispatch(
        ErrorActions.errorHandler({
          error: err,
          errorLocation: 'component.FilterTabs.initializeFilterLabels',
          errorClass: 'listingEngineActions',
        }),
      );
    }
  };

  const initialize = () => {
    // Get listings excluded per filter
    fetchNumListingsExcludedPerFilter();

    // Get total listings excluded from all filters
    fetchTotalNumListingsExcluded();
  };

  const handleClearAllFilters = () => yieldCallback(dispatch(DEPRECATED_FilterActions.resetFilterAndNotify()));

  const _yieldFilterItemRemovalDesktop = yieldCallback((key) => {
    dispatch(DEPRECATED_FilterActions.partialResetFilter({ key }));
  });

  const handleFilterItemRemoval = (key) => {
    _yieldFilterItemRemovalDesktop(key);
  };

  return {
    initialize,
    handleClearAllFilters,
    handleFilterItemRemoval,
    filterLabels,
    filterLabelCounts,
    isLoading,
  };
};
